import { render, staticRenderFns } from "./AdditionalNotes.vue?vue&type=template&id=89070118&scoped=true"
import script from "./AdditionalNotes.vue?vue&type=script&lang=ts"
export * from "./AdditionalNotes.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalNotes.vue?vue&type=style&index=0&id=89070118&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89070118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89070118')) {
      api.createRecord('89070118', component.options)
    } else {
      api.reload('89070118', component.options)
    }
    module.hot.accept("./AdditionalNotes.vue?vue&type=template&id=89070118&scoped=true", function () {
      api.rerender('89070118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/ClientProfileSteps/AdditionalNotes.vue"
export default component.exports